import React, { Suspense } from "react";

const CspCourierHome = React.lazy(() => import("./CspCourierHome"));
const CspCourierServices = React.lazy(() => import("./CspCourierServices/CspCourierServices"));

const CspCourier = () => {
    return (
        <div className="about">
            <Suspense fallback={<div>Loading Home...</div>}>
                <CspCourierHome />
            </Suspense>
            <Suspense fallback={<div>Loading Services...</div>}>
                <CspCourierServices />
            </Suspense>
        </div>
    );
};

export default CspCourier;
